import React, { FC } from 'react'
import { useLocalization } from '@components/Localization'
import { Box, Heading } from '@gassan-ui'
import { Link } from '@gassan-ui'

type Props = {}

const ErrorState: FC<Props> = () => {
  const { lang } = useLocalization()
  return (
    <Box>
      <Heading variant="h3" as="h3" mb=".5rem">
        {lang === 'nl' ? 'Er  ging iets mis.' : 'Something went wrong.'}
      </Heading>
      <Link as="button" onClick={() => window.location.reload()}>
        {lang === 'nl' ? 'Probeer opnieuw' : 'Try again'}
      </Link>
    </Box>
  )
}

export default ErrorState
